export const CHECK_MSV_REQUEST = "CHECK_MSV_REQUEST";
export const CHECK_MSV_SUCCESS = "CHECK_MSV_SUCCESS";
export const CHECK_MSV_ERROR = "CHECK_MSV_ERROR";
